// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"styles__msignaturepad___3WA_M","m-signature-pad--body":"styles__m-signature-pad--body___xtA2Z","m-signature-pad--footer":"styles__m-signature-pad--footer___1-Tnz","description":"styles__description___2W00F","button":"styles__button___3k_bG","clear":"styles__clear___260_H","save":"styles__save___3OERP","m-signature-pad":"styles__m-signature-pad___zs6dA","github":"styles__github___3udTo","flexListItem":"styles__flexListItem___VEKys","text":"styles__text___3K7ho","dropdown":"styles__dropdown___24CSp","check":"styles__check___1cl5f"};


//////////////////
// WEBPACK FOOTER
// ./client/app/shared/components/Filters/styles.scss
// module id = hG6Q
// module chunks = client